import React from 'react'

export default function PersonAddOutline(props) {
    return (
        <svg {...props} width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1.66797 17.5C1.6679 16.217 2.03808 14.9612 2.73409 13.8833C3.4301 12.8054 4.42236 11.9513 5.5918 11.4234C6.76124 10.8955 8.05817 10.7163 9.32693 10.9073C10.5957 11.0983 11.7824 11.6513 12.7446 12.5'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.33464 10.8333C10.6358 10.8333 12.5013 8.96785 12.5013 6.66667C12.5013 4.36548 10.6358 2.5 8.33464 2.5C6.03345 2.5 4.16797 4.36548 4.16797 6.66667C4.16797 8.96785 6.03345 10.8333 8.33464 10.8333Z'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M15.832 13.3335V18.3335'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.332 15.8335H13.332'
                stroke='currentColor'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    )
}
